import jqRequest from '../jqRequest'
import activityUrls from '../urls/activity'

export default {
  // 获取活动详情
  getActivityDetail(data) {
    return jqRequest.requestWithToken(activityUrls.getActivityDetail, data);
  },
  // 通过活动Id和用户Id获取会员的报名状况
  getApplyStatus(data) {
    return jqRequest.requestWithToken(activityUrls.getApplyStatus, data);
  },
  // 通过活动Id和电话获取会员的报名状况
  getApplyStatusByActivityIdAndPhone(data) {
    return jqRequest.requestWithToken(activityUrls.getApplyStatusByActivityIdAndPhone, data);
  },
  // 获取用户报名详细（基础信息和动态字段信息）
  getApplyMemberDetail(data) {
    return jqRequest.requestWithToken(activityUrls.getApplyMemberDetail, data);
  },
  // 获取报名自定义表单
  getApplyMemberModelByActivityId(data){
    return jqRequest.requestWithToken(activityUrls.getApplyMemberModelByActivityId, data);
  },
  // 会员报名
  addApplyMember(data){
    return jqRequest.requestWithToken(activityUrls.addApplyMember, data);
  },
  // 会员报名并签到
  addApplyMemberAndSignIn(data){
    return jqRequest.requestWithToken(activityUrls.addApplyMemberAndSignIn, data);
  },
  // 获取参赛作品自定义表单
  getApplyFormModelByActivityId(data){
    return jqRequest.requestWithToken(activityUrls.getApplyFormModelByActivityId, data);
  },
  // 会员提交参赛作品
  addApplyForm(data){
    return jqRequest.requestWithToken(activityUrls.addApplyForm, data);
  },
  // 会员修改参赛作品
  updateApplyFormForYTH(data){
    return jqRequest.requestWithToken(activityUrls.updateApplyFormForYTH, data);
  },
  // H5签到页面获取短信验证码
  getAuthCodeBySignIn(data){
    return jqRequest.requestWithToken(activityUrls.getAuthCodeBySignIn, data);
  },
  // 签到
  activitySignInByPhone(data){
    return jqRequest.requestWithToken(activityUrls.activitySignInByPhone, data);
  },
  // 根据活动ID和会员ID判断是否已经签到
  isSignIn(data){
    return jqRequest.requestWithToken(activityUrls.isSignIn, data);
  },
  // 根据活动Id查询参赛作品列表
  listApplyFormByActivityId(data){
    return jqRequest.requestWithToken(activityUrls.listApplyFormByActivityId, data);
  },
  // 根据活动Id查询参赛作品列表
  listApplyFormByCondition(data){
    return jqRequest.requestWithToken(activityUrls.listApplyFormByCondition, data);
  },
  // 根据活动Id和会员Id查询参赛作品列表
  listApplyFormByMemberId(data){
    return jqRequest.requestWithToken(activityUrls.listApplyFormByMemberId, data);
  },
  // 参赛作品投票
  topApplyForm(data){
    return jqRequest.requestWithToken(activityUrls.topApplyForm, data);
  },
  // 参赛作品详情
  getApplyFormDetail(data){
    return jqRequest.requestWithToken(activityUrls.getApplyFormDetail, data);
  },
}